import * as React from "react";
import { isEmail } from "validator";
import { Link as RouterLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Button, Link, Stack, TextField } from "@mui/material";
import { forgetPassword } from "../../actions/Auth";
import AuthShell from "../../ui/AuthShell";

// Asks for the email to send a reset link to
const ResetPassword = () => {
  const currentUrl = new URL(window.location.href);
  const url = `${currentUrl.protocol}//${currentUrl.host}/insurance/resetMyPassword`;
  const [email, setEmail] = React.useState("");
  const [error, setError] = React.useState("");
  const [sent, setSent] = React.useState(false);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  async function sendData(e) {
    e.preventDefault();
    if (!isEmail(email)) return setError("Enter a valid email address.");
    setError("");
    await dispatch(forgetPassword({ email, url }));
    setSent(true);
  }

  return (
    <AuthShell title="Forgot your password?" subtitle="Enter your email and we will send you a link to set a new one.">
      <Stack component="form" onSubmit={sendData} gap={2.25}>
        {sent && auth.emailSentError && <Alert severity="error">{auth.emailSentError}</Alert>}
        {sent && auth.emailSent && <Alert severity="success">{auth.emailSent}</Alert>}
        <TextField
          label="Email address"
          type="email"
          autoFocus
          fullWidth
          size="medium"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={Boolean(error)}
          helperText={error}
        />
        <Button type="submit" variant="contained" size="large">
          Send reset link
        </Button>
        <Link component={RouterLink} to="/insurance/login" variant="body2" underline="hover" sx={{ textAlign: "center" }}>
          Back to log in
        </Link>
      </Stack>
    </AuthShell>
  );
};

export default ResetPassword;
